<script>
	import Navbar from "./components/Navbar.svelte";
	import Svelecte from "svelecte";
	import Clipboard from "svelte-clipboard";
	import Footer from "./components/Footer.svelte";
	import {
		api_spawnExperiment,
		api_pullEntitySets,
		excludeSets,
		formMap,
	} from "./stores.js";
	import { parseFormdata, arrayObjects2CSV, sortByKey } from "./utils.js";
	import {
		textConsent,
		textInstructions,
		redirectLucid,
		redirectProlific,
		redirectMTurk,
	} from "./placeholderText.js";
	import { getContext } from "svelte";
	import ViewMarkdown from "./modals/ViewMarkdown.svelte";
	import { useForm } from "svelte-use-form";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	// modal to render markdown
	const { open, close } = getContext("simple-modal");
	const viewMarkdown = (text) =>
		open(ViewMarkdown, { text: text, onClose: close });

	const form = useForm();
	let finalParams;
	let formSubmitted = false;
	let copiedID = false;
	let copiedIDText = "Copy ID";
	let copiedURL = false;
	let copiedURLText = "Copy URL";
	let downloadParamsText = "Download";
	let message = "";
	let secret = "";
	let secretCode = SECRET_CODE;
	let conditions = 1;
	let entitySetsCopy;
	let experiment_id;
	let studyURL = "https://www.yourfeed.social";
	let platform;
	let redirectExample;
	let randomizeCardsBetweenSubjects = ["yes"];
	let cardCategories = ["news"];
	let buttons = ["share", "like", "bookmark", "accuracy"];
	let consentText = textConsent;
	let forms = Object.keys($formMap);
	let formsSelected = [];

	let selectionSets = [];
	let selectedSets = [];
	let selectedSetsParsed = {};
	const updateSelectedSets = (cardCategory, conditionidx) => {
		const sets = selectionSets[conditionidx][cardCategory];
		selectedSets[conditionidx][cardCategory] = sets.map((s) => s.label);
		console.log("selectedSets:", selectedSets);

		if (conditions == 0) {
			selectedSetsParsed = {};
			return;
		}

		// loop through objects/sets in conditions
		selectedSets.forEach((conditionSets, csi) => {
			let entities = [];
			for (const key in conditionSets) {
				let set = conditionSets[key];
				set.forEach((si) => {
					// catch weird bug with Svelecte
					if (Object.keys(si).includes("label")) {
						si = si["label"];
					}
					console.log("csi si", csi, si);
					const setname = si.slice(0, si.indexOf(" ["));
					const maxCards = entitySetsCopy["entity_set_n"][setname];
					let obj = {
						entity_set: setname,
						number_to_show: maxCards,
						randomize_between_subjects:
							randomizeCardsBetweenSubjects[csi],
					};
					entities.push(obj);
				});
			}
			selectedSetsParsed[csi] = entities;
		});
		console.log("selectedSetsParsed:", selectedSetsParsed);
	};

	const updateSelectedSetValues = (setName, conditionidx, numberToShow) => {
		const sets = selectedSetsParsed[conditionidx];
		for (let j = 0; j < sets.length; j++) {
			if (sets[j]["entity_set"] === setName) {
				selectedSetsParsed[conditionidx][j]["number_to_show"] =
					numberToShow;
				selectedSetsParsed[conditionidx][j][
					"randomize_between_subjects"
				] = randomizeCardsBetweenSubjects[conditionidx];
			}
		}
		console.log("selectedSetsParsed:", selectedSetsParsed);
	};

	const updateRandomizeCards = (conditionidx) => {
		const sets = selectedSetsParsed[conditionidx];
		for (let j = 0; j < sets.length; j++) {
			selectedSetsParsed[conditionidx][j]["randomize_between_subjects"] =
				randomizeCardsBetweenSubjects[conditionidx];
		}
		console.log("selectedSetsParsed:", selectedSetsParsed);
	};
	$: if (conditions >= 0) {
		if (conditions === 0) {
			randomizeCardsBetweenSubjects = [];
		}
		if (conditions > randomizeCardsBetweenSubjects.length) {
			randomizeCardsBetweenSubjects.push("yes");
		}
		if (randomizeCardsBetweenSubjects.length > conditions) {
			randomizeCardsBetweenSubjects.pop();
		}
		console.log(
			"randomizeCardsBetweenSubjects",
			randomizeCardsBetweenSubjects
		);
	}

	const updateSelected = (conditions) => {
		if (conditions == 0) {
			selectionSets = [];
			selectedSets = [];
			console.log("selectionSets updated", selectionSets);
			console.log("selectedSets updated", selectedSets);
			return;
		}
		const condAdd = conditions - selectedSets.length;
		console.log("conditions:", conditions);
		console.log("condAdd:", condAdd);
		if (condAdd > 0) {
			for (let c = 0; c < condAdd; c++) {
				let temp_selectionSets = {};
				let temp_selectedSets = {};
				for (let i = 0; i < cardCategories.length; i++) {
					temp_selectionSets[cardCategories[i]] = [];
					temp_selectedSets[cardCategories[i]] = [];
				}
				selectionSets.push(temp_selectionSets);
				selectedSets.push(temp_selectedSets);
				selectedSetsParsed[conditions - 1] = [];
			}
		} else if (condAdd < 0) {
			selectionSets = selectionSets.slice(0, conditions);
			selectedSets = selectionSets.slice(0, conditions);
			delete selectedSetsParsed[conditions];
		}
		console.log("selectionSets updated", selectionSets);
		console.log("selectedSets updated", selectedSets);
		console.log("selectedSetsParsed:", selectedSetsParsed);
	};
	$: updateSelected(conditions);

	const getConditionSets = () => {
		let obj = {};
		for (let c = 0; c < conditions; c++) {
			// unpack/merge arrays
			let temp = [].concat.apply([], Object.values(selectedSets[c]));
			const tempKey = "condition-" + (c + 1) + ";entity-sets";
			obj[tempKey] = temp;
		}
		console.log("formatted entity_sets", obj);
		return obj;
	};

	let interventionsTypes = [""];
	let interventionsDisabled = [true];
	let showInterventionOptions = false;
	const updateInterventions = (conditions, interventionsTypes) => {
		if (conditions > interventionsTypes.length) {
			interventionsTypes = [...interventionsTypes, ""];
			interventionsDisabled = [...interventionsDisabled, true];
		}
		// determine whether to disable intervention slider and style
		interventionsTypes.forEach((t, i) => {
			if (t != "") {
				interventionsDisabled[i] = false;
			} else {
				interventionsDisabled[i] = true;
			}
		});
		interventionsTypes = interventionsTypes.slice(0, conditions);
		interventionsDisabled = interventionsDisabled.slice(0, conditions);
		if (interventionsTypes.filter((i) => i != "").length > 0) {
			showInterventionOptions = true;
		} else {
			showInterventionOptions = false;
		}
	};
	$: updateInterventions(conditions, interventionsTypes);

	const updateRedirectExample = () => {
		if (platform == "lucid") {
			redirectExample = redirectLucid;
		} else if (platform == "prolific") {
			redirectExample = redirectProlific;
		} else if (platform == "mturk") {
			redirectExample = redirectMTurk;
		} else {
			redirectExample = undefined;
		}
	};
	$: if (platform) {
		updateRedirectExample();
	}

	const handleClick = () => {
		formSubmitted = true;
		let responses = parseFormdata($form);

		// add forms
		responses["forms"] = formsSelected;

		// delete unused keys
		delete responses["svelecte"];
		delete responses[""];

		// check if all conditions have sets
		for (const key in selectedSetsParsed) {
			if (selectedSetsParsed[key].length == 0) {
				message =
					"You need to select at least one set per condition under the Cards section.";
				console.log(message);
				return selectedSetsParsed;
			}
		}
		console.log("responses", responses);

		// if intervention-type is "", then set intervention-perc to ""
		for (let i = 1; i < conditions + 1; i++) {
			let interventionType =
				responses["condition-" + i + ";intervention-type"];
			if (interventionType == "") {
				responses["condition-" + i + ";intervention-perc"] = "";
			}
		}

		// format data for API
		let conditionSettings = [];
		Object.keys(responses).forEach((i) => {
			let obj = {};
			let cond_param = i.split(";");
			let condition = Number(cond_param[0].replace("condition-", ""));
			// console.log(cond_param, condition);
			if (!isNaN(condition)) {
				obj["condition"] = condition;
				obj["param"] = cond_param[1];
				obj["value"] = responses[i];
				if (obj["value"] === "0" || obj["value"] === "no") {
					obj["value"] = "";
				}
				conditionSettings.push(obj);
			}
		});

		// manually duplicate params for each condition
		for (let i = 1; i < conditions + 1; i++) {
			// params to manually duplicate
			const params = [
				"platform",
				"redirect-url",
				"completion-code",
				"consent",
			];
			params.forEach((param) => {
				if (param !== undefined) {
					let obj = {
						condition: i,
						param: param,
						value: encodeURIComponent(responses[param]),
					};
					conditionSettings.push(obj);
				}
			});

			// add n-conditions
			let obj = {
				condition: i,
				param: "n-conditions",
				value: conditions,
			};
			conditionSettings.push(obj);

			// add forms
			obj = {
				condition: i,
				param: "forms",
				value: JSON.stringify(formsSelected),
			};
			conditionSettings.push(obj);
		}

		// if feed algorithm is not random, show all cards in all sets
		const feedAlg = conditionSettings.filter((i) => i.param == "algorithm");
		for (let i = 0; i < conditions; i++) {
			if (feedAlg[i].value !== "random") {
				entitySets.then(function (result) {
					// console.log(result.entity_set_n)
					// loop each array in selectedSetsParsed and update the number of cards
					for (let j = 0; j < selectedSetsParsed[i].length; j++) {
						const setName = selectedSetsParsed[i][j].entity_set;
						selectedSetsParsed[i][j].number_to_show =
							result.entity_set_n[setName];
					}
				});
			}
		}
		console.log("selectedSetsParsed", selectedSetsParsed);

		// add entitysets for each condition
		// add sets to responses
		for (const key in selectedSetsParsed) {
			const conditionEntities = selectedSetsParsed[key];
			let obj = {
				condition: Number(key) + 1,
				param: "entity_sets",
				value: JSON.stringify(conditionEntities),
			};
			conditionSettings.push(obj);
		}

		// convert null or undefined to entity_sets (avoid JSON errors in server)
		conditionSettings.forEach((obj, idx) => {
			if (obj.value === "null" || obj.value === "undefined") {
				conditionSettings[idx].value = "";
			}
		});

		// convert "" feed-button values to "no"
		conditionSettings.forEach((obj, idx) => {
			if (obj.param.includes("feed-button-") && obj.value === "") {
				conditionSettings[idx].value = "no";
			}
		});

		// sort
		conditionSettings = sortByKey(conditionSettings, "condition");
		conditionSettings = sortByKey(conditionSettings, "param");
		console.log("conditionSettings", conditionSettings);
		finalParams = conditionSettings;
		if (secret !== secretCode) {
			message = "🤖 Wrong secret code! Are you human? 🤖";
		} else {
			spawnExperiment(conditionSettings);
		}
	};

	async function spawnExperiment(conditionSettings) {
		console.log("Spawning experiment...");
		const resp = await fetch($api_spawnExperiment, {
			method: "POST",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				condition_settings: conditionSettings,
			}),
		});
		const response = await resp.json();
		let data;
		if (response.success === "true") {
			console.log("Created experiment successfully");
			data = response.data;
			experiment_id = data.experiment_id;
			studyURL += "?experiment_id=" + experiment_id;
			message = "Study created: ";
		} else {
			console.log("Failed to create experiment");
			message = "Whoops, failed to create study.";
		}
	}

	async function pullEntitySets() {
		console.log("Pulling entity sets...");
		const resp = await fetch($api_pullEntitySets, {
			method: "GET",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		});
		const response = await resp.json();
		let data;
		let obj = {};
		if (response.success === "true") {
			console.log("Pulled entity sets successfully");
			data = JSON.parse(response.data.entity_sets);
			// ignore test category
			data = data.filter((d) => d.entity_category !== "test");
			console.log(data);
			// exclude sets in $excludeSets
			data = data.filter((d) => !$excludeSets.includes(d.entity_set));

			// get categories
			cardCategories = data.map((i) => i.entity_category);
			// get unique categories
			cardCategories = cardCategories
				.filter((v, i, a) => a.indexOf(v) === i)
				.sort();
			obj["data"] = data;
			obj["cardCategories"] = cardCategories;

			// n entities per set
			let entity_set_n = {};
			obj.data.forEach((i) => {
				entity_set_n[i.entity_set] = i.num_entities;
			});
			obj.entity_set_n = entity_set_n;

			// get entity sets for each category
			obj["entity_sets"] = {};
			cardCategories.forEach((c) => {
				let entity_sets = data.filter((d) => d.entity_category === c);
				entity_sets = entity_sets.map((e) => e.entity_set);
				// add no. of cards in each set (setname [count])
				let entity_set_newnames = [];
				entity_sets.forEach((i) => {
					const n = entity_set_n[i];
					entity_set_newnames.push(i + " [" + n + "]");
				});
				obj["entity_sets"][c] = entity_set_newnames;
			});

			updateSelected(conditions);

			console.log("entity sets", obj);
		} else {
			console.log("Failed to pull entity sets");
		}
		entitySetsCopy = obj;
		return obj;
	}
	let entitySets = pullEntitySets();

	const toCSV = (data) => {
		data = sortByKey(data, "condition");
		data = sortByKey(data, "param");
		console.log(data);
		let csv = arrayObjects2CSV(data);

		// document.write(csv);
		let hiddenElement = document.createElement("a");
		hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
		hiddenElement.target = "_blank";
		let filename = experiment_id + "_experiment_parameters.csv";
		hiddenElement.download = filename;
		hiddenElement.click();
	};
</script>

<Navbar />

<h1>Specify study parameters</h1>

<section>
	<!-- conditions-n  -->
	<label for="conditions-n"><h3>Number of conditions</h3></label>
	<input
		name="condition-n"
		type="number"
		bind:value={conditions}
		style="width:89px"
	/>

	<!-- card types -->
	{#if conditions > 0}
		<hr />
		<h3>Cards</h3>
		<p>Number of cards in each set are in brackets</p>
		{#await entitySets then data}
			{#each { length: conditions } as _, ii}
				{#if conditions > 1}
					<p>Condition {ii + 1}</p>
				{/if}
				{#each data.cardCategories as cardCategory, cti}
					<p style="font-size:0.9em;">Category: {cardCategory}</p>
					<Svelecte
						options={data.entity_sets[cardCategory]}
						bind:readSelection={selectionSets[ii][cardCategory]}
						on:change={() => updateSelectedSets(cardCategory, ii)}
						multiple
						placeholder={"Select set(s) for " +
							cardCategory +
							" cards"}
						style="width:100%"
					/>
				{/each}

				{#if Object.keys(selectedSetsParsed).length > 0}
					{#if selectedSetsParsed[[ii]] !== undefined && selectedSetsParsed[[ii]].length > 0}
						<p style="font-size:0.9em;">
							<em
								>Optional: Indicate how many card to randomly
								select from each set (default is all)
							</em>
						</p>

						{#each selectedSetsParsed[ii] as set, seti}
							<span style="font-size:0.8em">
								<label
									for={"condition-" +
										(ii + 1) +
										";numCards-" +
										set.entity_set}
									class="card-label">{set.entity_set}</label
								>
								<input
									name={"condition-" +
										(ii + 1) +
										";numCards-" +
										set.entity_set}
									type="number"
									list="button-options"
									class="button-input"
									min="1"
									max={entitySetsCopy["entity_set_n"][
										set.entity_set
									]}
									style="width: 70px;"
									bind:value={selectedSetsParsed[ii][seti]
										.number_to_show}
									on:change={() =>
										updateSelectedSetValues(
											set.entity_set,
											ii,
											selectedSetsParsed[ii][seti]
												.number_to_show
										)}
								/>
							</span>
						{/each}

						<p style="font-size:0.9em;">
							<em
								>Optional: Randomly subsample different cards
								for different participants? (default is yes)</em
							>
						</p>

						<label for={"condition-" + (ii + 1) + ";numCards"} />
						<select
							name={"condition-" + (ii + 1) + ";numCards"}
							bind:value={randomizeCardsBetweenSubjects[ii]}
							on:change={() => updateRandomizeCards(ii)}
						>
							<option value="yes">yes</option>
							<option value="no">no</option>
						</select>
					{/if}
				{/if}
			{/each}
		{/await}
		<br />
		<hr />
	{/if}

	{#if conditions > 0}
		<form use:form>
			<!-- buttons  -->
			<h3>Buttons</h3>
			<p>
				If you do not select any button (default <code>no</code>), all
				buttons will be shown.
			</p>
			<p>
				If you want only a button but not any social cues/engagement
				info, enter <code>yes</code>.
			</p>
			<p>
				If you want a button <strong>and</strong> social cues/engagement
				info, enter <code>lognormal</code>.
			</p>
			{#each { length: conditions } as _, ii}
				{#if conditions > 1}
					<p>Condition {ii + 1}</p>
				{/if}
				{#each buttons as button}
					<div class="button-container">
						<label
							for={"condition-" +
								(ii + 1) +
								";feed-button-" +
								button}
							class="card-label">{button}</label
						>
						<input
							name={"condition-" +
								(ii + 1) +
								";feed-button-" +
								button}
							type="text"
							list="button-options"
							class="button-input"
							placeholder="no"
						/>
						<datalist id="button-options">
							<option value="no" />
							<option value="yes" />
							<option value="lognormal" />
						</datalist>
					</div>
				{/each}
			{/each}
			<hr />

			<!-- intervention  -->
			<h3>Intervention type</h3>
			{#each { length: conditions } as _, ii}
				{#if conditions > 1}
					<p>Condition {ii + 1}</p>
				{/if}
				<div>
					<label
						for={"condition-" + (ii + 1) + ";intervention-type"}
					/>
					<select
						name={"condition-" + (ii + 1) + ";intervention-type"}
						bind:value={interventionsTypes[ii]}
					>
						<option value="">None</option>
						<option value="accprompt">Accuracy prompt</option>
						<option value="literacytip">Literacy tip</option>
						<option value="socialnorm">Social norm</option>
						<option value="importance">Importance</option>
					</select>
				</div>
			{/each}

			{#if showInterventionOptions}
				<h3>Intervention style</h3>
				{#each { length: conditions } as _, ii}
					{#if conditions > 1}
						<p>Condition {ii + 1}</p>
					{/if}
					<div>
						<label
							for={"condition-" +
								(ii + 1) +
								";intervention-style"}
						/>
						<select
							name={"condition-" +
								(ii + 1) +
								";intervention-style"}
							disabled={interventionsDisabled[ii]}
						>
							<option value="">None</option>
							<option value="modal">Modal/popup (default)</option>
							<option value="infeed"
								>In-feed (coming soon!)</option
							>
						</select>
					</div>
				{/each}

				<h3>Percent through study intervention will appear</h3>
				{#each { length: conditions } as _, ii}
					{#if conditions > 1}
						<p>Condition {ii + 1}</p>
					{/if}
					<div class="slider">
						<input
							name={"condition-" +
								(ii + 1) +
								";intervention-perc"}
							disabled={interventionsDisabled[ii]}
							type="range"
							min="0"
							max="100"
							value="50"
							step="5"
							oninput={"perccondition" +
								(ii + 1) +
								".innerText = this.value"}
						/>
						<span id={"perccondition" + (ii + 1)} />
					</div>
				{/each}
			{/if}
			<hr />

			<!-- skin  -->
			<h3>Which skin to use?</h3>
			{#each { length: conditions } as _, ii}
				{#if conditions > 1}
					<p>Condition {ii + 1}</p>
				{/if}
				<div>
					<label for={"condition-" + (ii + 1) + ";skin"} />
					<select name={"condition-" + (ii + 1) + ";skin"}>
						<option value="">Default</option>
						<option value="distract"
							>Distracting (coming soon!)</option
						>
					</select>
				</div>
			{/each}
			<hr />

			<!-- feed algorithm  -->

			<h3>Which news feed algorithm?</h3>
			<p style="font-size:0.9em;">
				<em
					>For all non-default (Random) options, <strong
						>all cards</strong
					> will be selected from each set (overwrites values indicated
					in the above Cards section).
				</em>
			</p>

			{#each { length: conditions } as _, ii}
				{#if conditions > 1}
					<p>Condition {ii + 1}</p>
				{/if}
				<div>
					<label for={"condition-" + (ii + 1) + ";algorithm"} />
					<select name={"condition-" + (ii + 1) + ";algorithm"}>
						<option value="random">Random (default)</option>
						<option value="engagement"
							>Engagement (coming soon!)</option
						>
						<option value="preference"
							>Preference (coming soon!)</option
						>
						<option value="thompson_sampling"
							>Thompson sampling (coming soon!)</option
						>
						<option value="will_smith_priority_control"
							>Will-Smith Control</option
						>
						<option value="will_smith_priority_treatment"
							>Will-Smith Treatment</option
						>
						<option value="attitude_filter_feed"
							>Attitude filter feed</option
						>
					</select>
				</div>
			{/each}
			<hr />

			<!-- questionnaires -->
			<h3>Post-experiment questionnaires</h3>
			<p>Select questionnaires (in the required order) to show</p>
			<Svelecte
				options={forms}
				labelAsValue={true}
				multiple
				placeholder="Order matters!"
				style="width:100%"
				bind:value={formsSelected}
			/>

			<!-- instructions per condition  -->
			<h3>Study instructions</h3>
			<p>
				Instructions to show at the start of the study (popup/modal).
				Use Markdown if you want to format the text.
			</p>
			{#each { length: conditions } as _, ii}
				{#if conditions > 1}
					<p>Condition {ii + 1}</p>
				{/if}
				<div>
					<label for={"condition-" + (ii + 1) + ";instruct"} />
					<textarea
						name={"condition-" + (ii + 1) + ";instruct"}
						rows="4"
						cols="50">{textInstructions}</textarea
					>
				</div>
			{/each}
			<hr />

			<!-- consent per condition  -->
			<h3>Informed consent</h3>
			<p>Use Markdown if you want to format the text.</p>
			<div>
				<label for="consent" />
				<textarea
					name={"consent"}
					rows="4"
					cols="50"
					bind:value={consentText}
				/>
			</div>
			<button
				on:click|preventDefault={() => {
					viewMarkdown(consentText);
				}}>View formatted consent</button
			>
			<hr />

			<!-- platform  -->
			<h3>Recruitment platform</h3>
			<div>
				<p>
					If None, participants will be asked to return to the home
					page.
				</p>
				<label for={"platform"} />
				<select name={"platform"} bind:value={platform}>
					<option value="">None</option>
					<option value="mturk">MTurk</option>
					<option value="prolific">Prolific</option>
					<option value="lucid">Lucid</option>
				</select>
			</div>

			{#if platform !== undefined && platform !== null && platform !== ""}
				{#if platform !== "mturk"}
					<!-- redirect url  -->
					<label for="redirect-url"
						><h3>Redirect or completion URL</h3></label
					>

					<p>
						Follow the instructions (for Qualtrics) on your
						recruitment platform and paste redirection/completion
						URL below.
					</p>
					<p>
						Example: <code>{redirectExample}</code>
					</p>
					<input name="redirect-url" type="text" style="width:89%" />
				{/if}

				<!-- completion code  -->
				{#if platform === "mturk"}
					<h3>Completion code</h3>
					<div class="field-container">
						<label for="completion-code" />
						<p>
							Completion code for your recruitment platform
							(recommended if your recruitment platform is MTurk)
						</p>
						<input name="completion-code" type="text" />
					</div>
				{/if}
			{/if}
			<hr />
		</form>
	{/if}

	{#if conditions > 0}
		<!-- secret  -->
		<h3>Secret code</h3>
		<div class="field-container">
			<label for="secret">Show us you're human.</label>
			<input name="secret" type="text" bind:value={secret} required />
		</div>

		{#if !experiment_id}
			<button disabled={false} on:click|preventDefault={handleClick}
				>Create Study</button
			>
		{/if}

		{#if formSubmitted && experiment_id}
			<hr />
			<h3>{message}{experiment_id}</h3>
			<p style="color:red">
				Save your experiment ID and URL! You'll need them to run your
				study and download data later. Also, download the parameters
				you've defined above.
			</p>
			<p class="created">
				<button
					on:click|preventDefault={() => {
						toCSV(finalParams);
					}}
					class="copy-button">{downloadParamsText}</button
				>
				<Clipboard
					text={experiment_id}
					let:copy
					on:copy={() => {
						copiedID = true;
						copiedIDText = "Copied ID";
					}}
				>
					<button on:click|preventDefault={copy} class="copy-button"
						>{copiedIDText}</button
					>
				</Clipboard>
				{#if copiedID}
					<span style="font-size:0.6em;margin-left:2px"
						>{experiment_id}</span
					>
				{/if}
				<Clipboard
					text={studyURL}
					let:copy
					on:copy={() => {
						copiedURL = true;
						copiedURLText = "Copied URL";
					}}
				>
					<button on:click|preventDefault={copy} class="copy-button"
						>{copiedURLText}</button
					>
				</Clipboard>
				{#if copiedURL}
					<span style="font-size:0.6em;margin-left:2px"
						>{studyURL}</span
					>
				{/if}
			</p>
		{:else if formSubmitted && !experiment_id}
			<p class="created" style="color:black">{message}</p>
		{/if}
	{/if}
</section>
<Footer />

<style>
	button {
		margin-bottom: 1px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 8px;
	}

	.field-container {
		margin-bottom: 13px;
	}

	.card-label {
		display: inline;
	}

	.button-input {
		width: 89px;
		display: inline;
	}

	.button-container {
		display: inline;
	}

	@media (max-width: 950px) {
		.button-container {
			display: block;
		}
	}

	.created {
		font-size: 1.3em;
		margin-bottom: 34px;
	}

	.slider {
		display: flex;
		align-items: center;
	}

	.copy-button {
		margin-left: 1px;
		margin-top: 0px;
		margin-bottom: 0px;
	}

	textarea {
		width: 89%;
		height: 89px;
	}
</style>
